import React from 'react';

import {
    withStyles, Grid,
} from '../../material-ui';
import AppUtils from '../../control/apputlis';



class MStatusBar extends React.Component {

    render() {
        let ios = AppUtils.getQueryVariable('ios');
        let webclip = (AppUtils.getQueryVariable('webclip') == 1) || AppUtils.isWebClip;
        return (
            <React.Fragment>
                {
                    (ios == 1 || webclip) && <Grid style={{
                        height: 'constant(safe-area-inset-top)',
                        height: 'env(safe-area-inset-top)',
                    }} />
                }
            </React.Fragment>
        );
    }
}

export default withStyles((theme) => ({


}))(MStatusBar);